// extracted by mini-css-extract-plugin
export default {"cls1":"PaperNewsStory-cls1_jPR","cls2":"PaperNewsStory-cls2_m79 PaperNewsStory-cls1_jPR","variant-dense":"PaperNewsStory-variant-dense_FHZ"};